import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from "@angular/router";
import { Observable, catchError, map, switchMap, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/service/auth.service";
import { AlertService } from "src/app/service/alert.service";
import { AppURL } from "src/app/app.url";
import { AccountURL } from "src/app/module/account/account.url";

@Injectable({ providedIn: 'root' })
export class HttpConfig implements HttpInterceptor {
    private _isUnauthorize: boolean = false;

    constructor(
        private _auth: AuthService,
        private _router: Router,
        private _alert: AlertService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let appendURL = /http|https|.json/.test(req.url) ? req.url : `${environment.apiURL}${req.url}`;
        // withCredentials: ส่ง HttpOnly cookie (access/refresh token) ไปกับทุก request
        const request = req.clone({ headers: this.appendHeaders(req.headers), url: appendURL, withCredentials: true });
        return next
            .handle(request)
            .pipe(map((c) => this._handleData(c)))
            .pipe(catchError((c) => this.handleException(c, request, next)));
    }

    /** ดักจับการทำงานผิดพลาดของ HTTP API Response */
    private _handleError(res: HttpErrorResponse) {
        let message = res.message;
        if (res.error && res.error.message) {
            message = res.error.message;
        }
        return throwError(() => new Error(message));
    }

    /** ดักจับการส่งข้อมูลกลับคืนมาของ HTTP API Response */
    private _handleData(res: HttpEvent<any>) {
        if (res instanceof HttpResponse) {
            // ตรวจ response ของ signin/signup/refresh ด้วย token_type (token จริงอยู่ใน cookie แล้ว)
            if (res.body && res.body.data && res.body.data.token_type === 'Bearer') {
                this._auth.saveToken(res.body.data);
                res.body.data = null;
            }
        }
        return res;
    }

    /** append headers (token อยู่ใน HttpOnly cookie แล้ว — ไม่ต้องแนบ Authorization header) */
    private appendHeaders(headers: HttpHeaders) {
        return headers;
    }

    /** handle error exception */
    private handleException(res: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler) {
        const _res: any = res;
        if (res.error) {
            if (res.error.message || res.error.Message) _res.message = res.error.message || res.error.Message;
            else if (res.error.title) _res.message = res.error.title;
        }
        if (res.status == 401 && this._auth.isLoggedIn && !this._isUnauthorize) {
            this._isUnauthorize = true;
            return this._auth.updateToken()
                .pipe(catchError(() => {
                    // refresh token ก็หมดอายุ/ใช้ไม่ได้แล้ว — เคลียร์ token แล้วแจ้งให้เข้าสู่ระบบใหม่
                    this._auth.saveToken(undefined);
                    this._isUnauthorize = false;
                    this._alert.dialog('เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง').then(() => {
                        this._router.navigate(['', AppURL.account, AccountURL.login]);
                    });
                    return throwError(() => _res);
                }))
                .pipe(map(() => req.clone({ headers: this.appendHeaders(req.headers), withCredentials: true })))
                .pipe(switchMap(request => next.handle(request)));
        }
        return throwError(() => _res);
    }
}